import type { NavigatorPhase } from './PhaseIndicator';
import type { ChatMessage, ReportData, TherapyRecommendation } from './useNavigatorChat';

export const GUEST_NAVIGATOR_CONVERSATION_KEY = 'reso_guest_navigator_conversation_v1';
export const GUEST_NAVIGATOR_SESSION_KEY = 'reso_guest_navigator_session_id_v1';

export function getGuestNavigatorSessionId(): string {
  let sessionId = localStorage.getItem(GUEST_NAVIGATOR_SESSION_KEY);
  if (!sessionId) {
    sessionId = `guest_${crypto.randomUUID()}`;
    localStorage.setItem(GUEST_NAVIGATOR_SESSION_KEY, sessionId);
  }
  return sessionId;
}

export interface NavigatorUiState {
  clickedServiceLinks: string[];
  quickReplies?: string[];
  detectedStage?: number | null;
  branchPromptShownAt?: string | null;
  branchChoice?: 'continue' | 'services' | 'save_later' | null;
}

export interface StoredNavigatorConversation {
  guestSessionId?: string;
  messages: ChatMessage[];
  phase: NavigatorPhase;
  reportData: ReportData;
  recommendations: TherapyRecommendation[];
  uiState: NavigatorUiState;
  updatedAt: string;
}

export function loadGuestNavigatorConversation(): StoredNavigatorConversation | null {
  try {
    const raw = localStorage.getItem(GUEST_NAVIGATOR_CONVERSATION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredNavigatorConversation;
    if (!Array.isArray(parsed.messages)) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveGuestNavigatorConversation(conversation: StoredNavigatorConversation) {
  localStorage.setItem(GUEST_NAVIGATOR_CONVERSATION_KEY, JSON.stringify({
    ...conversation,
    guestSessionId: conversation.guestSessionId || getGuestNavigatorSessionId(),
  }));
}

export function clearGuestNavigatorConversation() {
  localStorage.removeItem(GUEST_NAVIGATOR_CONVERSATION_KEY);
}